// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"10":"aa88e481","744":"11ce6e80"}[chunkId] + ".js";
};